import styled from "styled-components";

export const StyledSection = styled.section`
  background-color: #ffffff;
  width: 100%;
  padding: 140px 48px 60px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;

  &::before {
    content: "";
    position: absolute;
    width: calc(100% - 48px * 2);
    height: 420px;
    left: 48px;
    top: 406px;
    background: #ffab95;
    filter: blur(260px);
    opacity: 0.4;
    z-index: 0;
    border-radius: 60px;
  }

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding: 100px 0.8rem 60px;
    gap: 40px;

    &::before {
      width: 100%;
      height: 293px;
      left: 0;
      top: 267px;
    }
  }

  @media (max-width: 689px) {
    &::before {
      width: 689px;
      left: calc((100% - 689px) / 2);
    }
  }
`;

export const Heading = styled.h2`
  color: rgba(29, 29, 29, 0.85);
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 44px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.02em;
  align-self: center;
  max-width: 100%;
  margin: 0 auto;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 28px;
    line-height: 1.3;
    letter-spacing: unset;

    br {
      display: none;
    }
  }
`;

export const HeadingHighlight = styled.span`
  color: rgba(29, 29, 29, 0.5);
  font-family: inherit;
`;

export const ContentWrapper = styled.div`
  z-index: 0;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  // display: none; /* Hide the entire carousel */

  @media ${({ theme }) => theme.media.mobile} {
    gap: 32px;
    max-width: calc(100% + 0.8rem + 0.8rem);
    width: calc(100% + 0.8rem + 0.8rem);
    margin-left: -0.8rem;
    margin-right: -0.8rem;
  }
`;

export const TestimonialsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(auto, 320px) 520px minmax(auto, 320px);
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: hidden;

  @media (max-width: 1200px) {
    grid-template-columns: 0.28fr 0.44fr 0.28fr;
  }

  @media ${({ theme }) => theme.media.mobile} {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    gap: 20px;
    padding-left: 16px;
    padding-right: 16px;
    overflow-x: scroll;
    scrollbar-width: none;
    scroll-snap-type: x mandatory;
    &::-webkit-scrollbar {
      display: none;
    }

    > * {
      scroll-snap-align: center;
      flex-shrink: 0;
    }
  }
`;

export const ControlsContainer = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 0;
`;

export const ControlButton = styled.button`
  background-color: #1d1d1d;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(29, 29, 29, 0.85);
  }

  @media ${({ theme }) => theme.media.mobile} {
    display: none;
  }
`;

export const ControlButtonIcon = styled.img`
  display: block;
  width: 16px;
  height: 16px;
  object-fit: contain;
`;

export const IndicatorsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const IndicatorDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ $isActive }) =>
    $isActive ? "#1D1D1D" : "rgba(29, 29, 29, 0.2)"};
  transition: background-color 0.2s ease;
`;
